import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  // Autocomplete,
  // IconButton,
  // TextField,
  // Tooltip,
} from "@mui/material";
// import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import moment from "moment";
import { useMutation } from "react-query";
import {
  downloadClaims,
  // getallStatus,
  UpdateClaimStatus,
} from "../../services";
import usePopup from "../../../hooks/usePopup";
import {
  // useContext,
  // useEffect,
  useState,
} from "react";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
// import { clinicId, createdById } from "../../../constants";
import { RemitanceActivityType } from "../types";
// import { ClaimContext, ClaimContextType } from "..";
// type StatusType = { id: number; verificationStatus: string };
function DetailsComponent({
  data,
  encounterId,
}: {
  data: RemitanceActivityType[] | null;
  encounterId: number;
}) {
  const { showSnackbar, CustomModal } = usePopup();
  // const {setRefetch} = useContext(ClaimContext) as ClaimContextType;
  const [claimDownloadType, setClaimDownloadType] = useState<boolean>(true);
  const [openDownloadModal, setOpenDownloadModal] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [verificationParam, setVerificationStatusParams] = useState<any>();
  const {
    // mutate: updateClaimStatus,
    isLoading: updateLoading,
  } = useMutation(UpdateClaimStatus, {
    onSuccess: (data) => {
      if (data.responseIndicator == "success") {
        setOpenConfirm(false);
        setVerificationStatusParams(null);
        showSnackbar({
          message: data.responseMessage,
          variant: "success",
          open: true,
          duration: 2000,
        });
      } else {
        showSnackbar({
          message: data.responseMessage,
          variant: "warning",
          open: true,
          duration: 2000,
        });
      }
    },
  });
  // const {
  //   mutate: getAllStatus,
  //   data: verificationStatusList,
  //   isLoading: statusLoading,
  // } = useMutation(getallStatus);
  const { 
    // mutate: downloadClaim,
     isLoading: downloadLoading } = useMutation(
    downloadClaims,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          if (result?.response) {
            try {
              const binaryData = atob(result.response.body);
              const byteNumbers = new Uint8Array(binaryData.length);
              for (let i = 0; i < binaryData.length; i++) {
                byteNumbers[i] = binaryData.charCodeAt(i);
              }
              const blob = new Blob([byteNumbers], {
                type: "application/json",
              });
              const blobURL = URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = blobURL;
              link.download = `Claim_download_${moment().format("DD-MM-YYYY hh:mm:ss A")}.json`;
              link.click();
              URL.revokeObjectURL(blobURL);
              showSnackbar({
                message: "Downloaded successfully !",
                variant: "success",
                duration: 2000,
                open: true,
              });
            } catch (error) {
              showSnackbar({
                message: "Failed to download file !",
                variant: "warning",
                duration: 2000,
                open: true,
              });
            }
          } else {
            showSnackbar({
              message: "Error",
              variant: "warning",
              duration: 2000,
              open: true,
            });
          }
        } else {
          showSnackbar({
            message: result.responseMessage,
            variant: "warning",
            duration: 2000,
            open: true,
          });
        }
      },
    }
  );

  const handleDownloadClaim = () => {
    console.log(encounterId,claimDownloadType)
    // downloadClaim({
    //   claims: [{ encounterId }],
    //   type: "SUBMISSION",
    //   isProduction: claimDownloadType,
    // });
  };

  // const handleVerificationStatusChange = () => {
  //   updateClaimStatus({
  //     ...verificationParam,
  //     verificationStatus: verificationParam?.verificationStatus?.id,
  //   });
  //   setRefetch(true)
  // };

  // const handleVerificationStatusConfirm = (_: any, option: any) => {
  //   if (Boolean(option)) {
  //     setVerificationStatusParams({
  //       encounterIds: [encounterId],
  //       verificationStatus: option,
  //       clinicId,
  //       createdById,
  //     });
  //     setOpenConfirm(true);
  //   }
  // };

  // useEffect(() => {
  //   getAllStatus();
  // }, []);

  return (
    <div className="p-3 flex flex-col gap-5 w-full h-full overflow-y-scroll">
      <CustomModal
        title="Claim Download"
        open={openDownloadModal}
        setOpen={setOpenDownloadModal}
      >
        <div className="p-3 w-[30vw] flex flex-col gap-2">
          <div className="flex gap-2 items-center justify-between">
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                row
                defaultValue={true}
              >
                <FormControlLabel
                  sx={{ fontSize: "10px" }}
                  value={false}
                  control={
                    <Radio
                      // value={claimDownloadType}
                      size="small"
                      onChange={() => {
                        setClaimDownloadType(false);
                      }}
                    />
                  }
                  label="Test"
                />
                <FormControlLabel
                  sx={{ fontSize: "8px" }}
                  value={true}
                  control={
                    <Radio
                      // value={claimDownloadType}
                      size="small"
                      onChange={() => {
                        setClaimDownloadType(true);
                      }}
                    />
                  }
                  label="Production"
                />
              </RadioGroup>
            </FormControl>
            <Button
              disabled={downloadLoading}
              endIcon={
                downloadLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <ArrowDownwardIcon />
                )
              }
              onClick={handleDownloadClaim}
            >
              download
            </Button>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        title="Change status"
        open={openConfirm}
        setOpen={setOpenConfirm}
      >
        <div className="p-3 w-[30vw] flex flex-col gap-2">
          <div className="h-[8vh]">
            Do you want to change the status to
            <strong>
              {verificationParam?.verificationStatus?.verificationStatus}
            </strong>{" "}
            ?
          </div>
          <div className="flex gap-2 items-center justify-end">
            <Button
              variant="text"
              color="error"
              onClick={() => {
                setOpenConfirm(false);
              }}
            >
              no
            </Button>
            <Button
              variant="text"
              color="success"
              endIcon={
                updateLoading && <CircularProgress size={18} color="success" />
              }
              // onClick={handleVerificationStatusChange}
            >
              yes
            </Button>
          </div>
        </div>
      </CustomModal>

      <div className="flex justify-between gap-2">
        <Typography variant="h6">Activity details</Typography>
        {/* <div className="w-[20vw] flex">
          {downloadLoading ? (
            <CircularProgress size={18} color="secondary" />
          ) : (
            <Tooltip title="Download claim">
              <IconButton
                color="secondary"
                onClick={() => {
                  setOpenDownloadModal(true);
                }}
              >
                <SimCardDownloadIcon />
              </IconButton>
            </Tooltip>
          )}
          <Autocomplete
            // disabled={updateLoading}
            fullWidth
            loading={statusLoading}
            options={verificationStatusList?.response || []}
            onChange={handleVerificationStatusConfirm}
            getOptionLabel={(option: StatusType) => option?.verificationStatus}
            isOptionEqualToValue={(option: StatusType, value: StatusType) =>
              option?.id === value?.id
            }
            renderInput={(params) => <TextField {...params} label="Status" />}
          />
        </div> */}
      </div>

      <div className="flex flex-row justify-start gap-5 w-full">
        <div className="border-2">
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>CPT Name</strong>
                </TableCell>
                <TableCell>
                  <strong>Denial Code</strong>
                </TableCell>
                <TableCell>
                  <strong>Denial description</strong>
                </TableCell>
                <TableCell>
                  <strong>CPT Code</strong>
                </TableCell>
                <TableCell>
                  <strong>Claim Id </strong>
                </TableCell>
                <TableCell>
                  <strong>Insurance Amount</strong>
                </TableCell>
                <TableCell>
                  <strong>Received Amount</strong>
                </TableCell>
                <TableCell>
                  <strong>Pending</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row, i) => (
                <TableRow
                  key={`activityDetails${i}`}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{row.cptName}</TableCell>
                  <TableCell>{row.denialCode}</TableCell>
                  <TableCell>{row.denialDescription}</TableCell>
                  <TableCell>{row.cptCode}</TableCell>
                  <TableCell>{row.claimId}</TableCell>
                  <TableCell>{row.insuranceAmount?.toFixed(2)}</TableCell>
                  <TableCell>{row.receivedAmount?.toFixed(2)}</TableCell>
                  <TableCell>{row.pending?.toFixed(2)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}

export default DetailsComponent;
